import React from 'react';
import {
    Spinner as ChakraSpinner,
    SpinnerProps,
    Flex,
    Text
} from '@chakra-ui/react';

export const Loading: React.FC<
    SpinnerProps & {
        text?: string;
        isFullScreen?: boolean;
    }
> = ({ text, isFullScreen, ...rest }) => {
    return (
        <Flex
            padding="4"
            justify="center"
            align="center"
            height={isFullScreen ? '100vh' : 'inherit'}>
            <Spinner {...rest} />
            {text && (
                <Text color="gray.500" marginLeft="4">
                    {text}
                </Text>
            )}
        </Flex>
    );
};

export function Spinner(props: SpinnerProps) {
    return <ChakraSpinner color="ecp.500" emptyColor="ecp.200" {...props} />;
}
